'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodashArrayFindIndex = require('lodash/array/findIndex');

var _lodashArrayFindIndex2 = _interopRequireDefault(_lodashArrayFindIndex);

var style = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box'
};

var optionType = _propTypes2['default'].shape({
  label: _propTypes2['default'].string.isRequired,
  value: _propTypes2['default'].any
});

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.InputSelect',

  propTypes: {
    value: _propTypes2['default'].any,
    options: _propTypes2['default'].arrayOf(optionType.isRequired).isRequired,
    onChange: _propTypes2['default'].func.isRequired
  },

  handleChange: function handleChange(e) {
    this.props.onChange(this.props.options[e.target.value].value);
  },

  renderOption: function renderOption(choice, index) {
    return _react2['default'].createElement(
      'option',
      { key: index, value: index },
      choice.label
    );
  },

  render: function render() {
    var _props = this.props;
    var options = _props.options;
    var value = _props.value;

    return _react2['default'].createElement(
      'select',
      {
        style: style,
        value: _lodashArrayFindIndex2['default'](options, function (x) {
          return x.value === value;
        }),
        onChange: this.handleChange
      },
      options.map(this.renderOption)
    );
  }

});
module.exports = exports['default'];